import { render, staticRenderFns } from "./EntriesSummary.vue?vue&type=template&id=90f57b1e"
import script from "./EntriesSummary.vue?vue&type=script&lang=js"
export * from "./EntriesSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports